// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"c8e452f5","203":"6109e9a1","239":"aca1805e","533":"81d90ecf","652":"9bc725a7","732":"bc7257ae","746":"f2dd0c1e","977":"2b2577a6"}[chunkId] + ".chunk.js";
};